export const PUBLISHER_SHOW_TABS = [
  'general',
  'publications',
  'collection',
  'search',
] as const;

export type PublisherShowTab = (typeof PUBLISHER_SHOW_TABS)[number];

export const PUBLISHER_DEFAULT_TAB: PublisherShowTab = 'general';
